import type { CountriesDictionary, Settings } from '@velasca/types'

export interface FormattedCountry {
  code: string
  label: string
}

/**
 * It takes an object of countries and returns an array of formatted countries.
 *
 * @param countriesDictionary - A dictionary of countries classified by their languageCode.
 * @param languageCode - The short-code that identifies the language of the country.
 */
export const formatCountries = (
  countriesDictionary: CountriesDictionary,
  languageCode: Settings['language'] = 'it',
): FormattedCountry[] => {
  const formattedCountries = []

  for (const [country, countryProperties] of Object.entries(
    countriesDictionary,
  )) {
    const uppercaseLanguageCode = languageCode.toUpperCase()
    const formattedCountry = {
      code: countryProperties.code,
      label: countryProperties.label[uppercaseLanguageCode],
    }

    country !== '' && formattedCountries.push(formattedCountry)
  }
  formattedCountries.sort((a, b) => (a.label < b.label ? -1 : 1))

  return formattedCountries
}
